import styled from "styled-components";
import svgBackground from "@assets/roadmap-graphic.svg";

export const IntroPanel = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  background: url(${svgBackground}), ${(props) => props.theme.gradients.light2};
  background-size: contain, contain;
  background-position: bottom right;
  background-repeat:
    no-repeat,
    repeat repeat;
  border-radius: 2px;
  padding: 1.5rem;

  ${(props) => props.theme.media.medium} {
    grid-template-columns: repeat(12, 1fr);
  }
`;

export const Content = styled.div`
  grid-column: span 1;
  p {
    font-size: 1rem;
    line-height: 1.4rem;
    font-weight: 300;
    & + p {
      margin-top: 1rem;
    }
  }
  ${(props) => props.theme.media.medium} {
    grid-column: span 7;
  }
`;

export const Heading = styled.h2`
  margin: 0px auto 1rem;

  ${(props) => props.theme.media.medium} {
    font-size: 2rem;
  }
`;
